import type { Organization } from '@hotjar/navigation/src/types';
import { DEMO_SITE_ORG } from '../../acquisition/demo/demo-site-redirections';
import { useAddToDemoSite } from './useAddToDemoSite';
import type { AddToDemoSite } from './useAddToDemoSite';

interface UseDemoSiteSelectorConfig {
  demoSiteOrg: Organization;
  isAddingToDemoSite: boolean;
  addToDemoSite: AddToDemoSite['addToDemoSite'];
}

export const useDemoSiteSelectorConfig = (): UseDemoSiteSelectorConfig => {
  const { isLoading: isAddingToDemoSite, addToDemoSite } = useAddToDemoSite();

  return {
    demoSiteOrg: DEMO_SITE_ORG,
    isAddingToDemoSite,
    addToDemoSite,
  };
};
